export enum AttributeObjectType {
	DOCUMENT = 'DOCUMENT',
	SENTENCE = 'SENTENCE',
	STUDIO_GROUPING = 'STUDIO_GROUPING'
}
